<app-top-back-bar #mobileTopBar></app-top-back-bar> 
<ngx-loading-bar></ngx-loading-bar>
<div [ngStyle]="{'padding-top': height}">
    <router-outlet></router-outlet>
</div>
<app-tap-to-top></app-tap-to-top>
<app-layout-box></app-layout-box>
<ng-template toastrContainer></ng-template>